import { Box, Container, Grid, Typography } from "@mui/material";

import defiIcon from "../../assets/defi.svg";
import deployIcon from "../../assets/deploy.svg";
import secureIcon from "../../assets/secure.svg";
import automationIcon from "../../assets/automation.svg";
import communityIcon from "../../assets/community.svg";

const FeatureCard = ({ icon, title, description }) => (
  <Box
    sx={{
      p: 4,
      height: "100%",
      border: "1px solid",
      borderColor: "rgba(13, 71, 255, 0.1)",
    }}
  >
    <Box
      component="img"
      src={icon}
      alt={title}
      sx={{
        width: 48,
        height: 48,
        mb: 3,
      }}
    />
    <Typography
      variant="h5"
      sx={{
        fontSize: "24px",
        fontWeight: 600,
        mb: 2,
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        fontSize: "16px",
        lineHeight: 1.6,
        color: "rgba(0, 0, 0, 0.7)",
      }}
    >
      {description}
    </Typography>
  </Box>
);

const WhyUs = () => {
  const features = [
    {
      icon: defiIcon,
      title: "DeFi + AI Expertise",
      description:
        "Proven experience in blockchain, money markets, staking, and yield strategies with AI integration.",
    },
    {
      icon: deployIcon,
      title: "Successful Deployments",
      description:
        "Our protocols Lendle, TAKOTAKO, and GMXBT are running on Mantle and Taiko with real-world adoption.",
    },
    {
      icon: secureIcon,
      title: "Scalable & Secure Solutions",
      description:
        "We ensure high-performance, security, and compliance across DeFi ecosystems.",
    },
    {
      icon: automationIcon,
      title: "AI-Driven Automation",
      description:
        "Enhancing risk management, governance, and investment with machine learning.",
    },
    {
      icon: communityIcon,
      title: "Community Focused",
      description:
        "We believe in open finance and accessible DeFi solutions for all.",
    },
  ];

  return (
    <Box sx={{ py: { xs: 4, md: 8 } }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "32px", md: "48px" },
            fontWeight: 400,
            mb: { xs: 6, md: 8 },
          }}
        >
          Why Partner with us?
        </Typography>

        <Grid container spacing={0}>
          {features.map((feature, index) => (
            <Grid
              item
              xs={12}
              md={4}
              key={index}
              sx={{
                // Make the last item centered if it's alone in its row
                ...(index === features.length - 1 && {
                  md: {
                    gridColumn: "auto / span 4",
                    maxWidth: "33.333%",
                    marginLeft: "auto",
                    marginRight: "auto",
                  },
                }),
              }}
            >
              <FeatureCard {...feature} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyUs;
